import * as React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Label } from "../../../../components/ui/label";
import { FieldError } from "../FieldError";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../components/ui/select";
import { cn } from "../../../../helpers/cn";

export function YearMonthPicker({
  label,
  name,
  step,
  className,
}) {
  const { control, watch } = useFormContext();
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1; // 1–12

  const years = Array.from({ length: 250 }, (_, i) => currentYear - i); // last 50 years
  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const selectedYear = watch(`${name}.year`);

  return (
    <div className={cn("flex flex-col gap-3", className)}>
      <Label className="px-1">{label}</Label>

      <div className="flex gap-4">
        {/* Year Select */}
        <Controller
          control={control}
          name={`${name}.year`}
          render={({ field }) => (
            <Select value={field.value || ""} onValueChange={field.onChange}>
              <SelectTrigger>
                <SelectValue placeholder="Year" />
              </SelectTrigger>
              <SelectContent className="max-h-60 overflow-y-auto">
                {years.map((yr) => (
                  <SelectItem key={yr} value={String(yr)}>
                    {yr}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}
        />

        {/* Month Select */}
        <Controller
          control={control}
          name={`${name}.month`}
          render={({ field }) => (
            <Select value={field.value || ""} onValueChange={field.onChange}>
              <SelectTrigger>
                <SelectValue placeholder="Month" />
              </SelectTrigger>
              <SelectContent className="max-h-60 overflow-y-auto">
                {months.map((m) => {
                  const isFuture =
                    selectedYear &&
                    Number(selectedYear) === currentYear &&
                    Number(m.value) > currentMonth;

                  return (
                    <SelectItem key={m.value} value={m.value} disabled={isFuture}>
                      {m.label}
                    </SelectItem>
                  );
                })}
              </SelectContent>
            </Select>
          )}
        />
      </div>

      {/* Show errors for year/month separately */}
      <div className="flex gap-4">
        <FieldError name={`${name}.year`} step={step} />
        <FieldError name={`${name}.month`} step={step} />
      </div>
    </div>
  );
}
